module.exports = __webpack_public_path__ + "static/badal-logo-7f382e73ec22dea5709a9f3c3cae1cd8.png";